export var ReportIntervalType;
(function (ReportIntervalType) {
    ReportIntervalType["DAY"] = "DAY";
    ReportIntervalType["WEEK"] = "WEEK";
})(ReportIntervalType || (ReportIntervalType = {}));
